export default {
  container: {
    boxSizing: 'content-box',
    width: 250,
    listStyleType: 'none',
    padding: '36px 20px',
    margin: 0,
    backgroundColor: '#f7f7f7',
    borderRight: '1px solid #ececec'
  },
  li: {
    padding: 4
  }
}



// WEBPACK FOOTER //
// ./src/docs/Navigation/styles.js